import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrdersListComponent } from './orders-list/orders-list.component';
import { OrdersComponent } from './orders.component';
import { OrdersRoutingModule } from './orders-routing.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { NbDialogModule, NbToastrModule, NbCardModule } from '@nebular/theme';
import { DialogChangeOrderComponent } from './dialog-change-order/dialog-change-order.component';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import {MenuModule} from "primeng/menu";
import { ProgressBarModule } from 'primeng/progressbar';

@NgModule({
  declarations: [
    OrdersListComponent,
    DialogChangeOrderComponent,
    OrdersComponent,
  ],
  imports: [
    RouterModule,
    FormsModule,
    CommonModule,
    OrdersRoutingModule,
    TableModule,
    ButtonModule,
    RippleModule,
    NbCardModule,
    NbToastrModule.forRoot(),
    NbDialogModule.forRoot(),
    PaginatorModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    MenuModule
  ],
})
export class OrdersModule { }
